import script from "./asideTab.vue?vue&type=script&setup=true&lang=js"
export * from "./asideTab.vue?vue&type=script&setup=true&lang=js"

import "./asideTab.vue?vue&type=style&index=0&id=efb542c6&scoped=true&lang=less"

import exportComponent from "D:\\git\\media-manage-web2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efb542c6"]])

export default __exports__